import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";

export const useSizeWizardText = (selectedSize?: number) => {
    const { getMultiple } = useMicrocopy();
    const microcopies = getMultiple(CommonCMS.shared, [
        CommonCMS.sizeWizard.selectSize,
        CommonCMS.sizeWizard.runsSmall,
        CommonCMS.sizeWizard.runsRegular,
        CommonCMS.sizeWizard.runsLarge,
    ]);

    const mapValueToBar = (value: number | undefined): number | null => {
        if (value === undefined || value === null) return null;
        if (value <= -0.5) return 1; // -1 to -0.5
        if (value <= -0.25) return 2; // -0.5 to -0.25
        if (value <= 0.25) return 3; // -0.25 to 0.25
        if (value <= 0.5) return 4; // 0.25 to 0.5
        return 5; // 0.5 to 1
    };

    const activeBar = mapValueToBar(selectedSize);

    const getRunsText = () => {
        if (activeBar === null) return microcopies[CommonCMS.sizeWizard.selectSize];
        if (activeBar <= 2) return microcopies[CommonCMS.sizeWizard.runsSmall];
        if (activeBar === 3) return microcopies[CommonCMS.sizeWizard.runsRegular];
        return microcopies[CommonCMS.sizeWizard.runsLarge];
    };

    const fullText = getRunsText();

    return {
        fullText,
        activeBar,
    };
};
